export default {
  methods: {
    addToast ({ message, title = undefined, variant = 'primary' }) {
      this.$root.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 5000,
        noCloseButton: false,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-bottom-right'
      })
    }
  }
}
